/**
 * @name ValidationType
 * @enum number
 * @type {{InvalidSpin: number,
 * MoneyTransactionError: number,
 * InvalidAmount: number,
 * InvalidToken: number,
 * NotEnoughMoney: number,
 * InvalidOperation: number,
 * InvalidSpinCount: number,
 * BuyBonusDisabled: number,
 * PartnerNotFound: number,
 * Success: number,
 * SpinNotFound: number}}
 */
export const ValidationType = {
  InvalidToken: 0,
  InvalidSpin: 1,
  MoneyTransactionError: 2,
  NotEnoughMoney: 3,
  InvalidOperation: 4,
  SpinNotFound: 5,
  InvalidSpinCount: 6,
  InvalidAmount: 7,
  BuyBonusDisabled: 8,
  PartnerNotFound: 9,
  Success: 10,
  InvalidSpinResult: 12,
  PlayerLimitExceeded: 14,
}